// Comments in English: sanitize user-provided HTML to prevent XSS
import DOMPurify from 'dompurify';

const ALLOWED_TAGS = [
  'a','b','i','em','strong','u','p','br','ul','ol','li','span','div',
  'img','h1','h2','h3','h4','h5','h6','blockquote','code','pre','hr'
];

const ALLOWED_ATTR = [
  'href','target','rel','class','style','src','alt','title'
];

export default function sanitizeHtml(input) {
  if (!input) return '';

  const clean = DOMPurify.sanitize(input, {
    ALLOWED_TAGS: ALLOWED_TAGS,
    ALLOWED_ATTR: ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
    FORBID_TAGS: ['script','style'],
    FORBID_ATTR: ['onerror','onload','onclick','onmouseover','onfocus','onblur'],
    USE_PROFILES: { html: true }
  });

  // Post-process anchors to enforce safe behavior
  const container = document.createElement('div');
  container.innerHTML = clean;

  container.querySelectorAll('a').forEach(a => {
    const href = a.getAttribute('href') || '';
    const isSafe = /^(https?:|mailto:|tel:|#|\/)/i.test(href);
    if (!isSafe) a.setAttribute('href', '#');
    a.setAttribute('target', '_blank');
    a.setAttribute('rel', 'noopener noreferrer');
  });

  return container.innerHTML;
}